module.exports = __webpack_public_path__ + "img/3T5.87ffa686.png";